module.exports = __webpack_public_path__ + "static/media/icon_75.9fe11c80.svg";